const comparisonRows = [
  ['Setup effort', 'Can require drivers, interfaces, DBC files, and expert configuration.', 'Designed for fast web entry points, demo mode, and clear capture workflows.'],
  ['Beginner friendliness', 'Powerful for experts but can be hard to interpret from raw frames alone.', 'Focuses on readable tables, summaries, filtering, and guided signal hints.'],
  ['AI assistance', 'Often manual or dependent on external notebooks and notes.', 'Designed to assist interpretation and organize candidate CAN decoding work.'],
  ['CAN log interpretation', 'Usually strong when the user already knows the format and definitions.', 'Browser Analyzer helps inspect logs, CAN IDs, bytes, frame rates, and exports.'],
  ['OBD workflow', 'OBD scanners are specialized for standardized diagnostics.', 'Supports generic OBD-II decoded responses where available and keeps raw frames visible.'],
  ['Developer examples', 'May require vendor-specific scripting or separate tooling.', 'VS Code and Python workflows are part of the SmartCAN product direction.']
];

export function SmartCANVsAlternatives() {
  return (
    <main className="seo-page">
      <section className="section page-shell seo-hero">
        <div>
          <p className="eyebrow">CAN tool comparison</p>
          <h1>SmartCAN vs Traditional CAN Tools</h1>
          <p className="lead">
            Traditional tools are powerful for experts, while SmartCAN focuses on fast interpretation, workflow, and
            AI-assisted analysis for CAN bus data, OBD workflows, and vehicle diagnostics.
          </p>
          <div className="hero-actions">
            <a className="button primary" href="/decode">Explore community signals</a>
            <a className="button secondary" href="/analyzer">Try the Analyzer</a>
            <a className="button ghost" href="/best-can-bus-tools">See tool categories</a>
          </div>
        </div>
      </section>

      <section className="section seo-content-grid">
        <article className="data-panel">
          <p className="eyebrow">Fair comparison</p>
          <h2>Traditional tools still matter</h2>
          <p>
            Established CAN tools are often ideal for expert users with known hardware, validated DBC files, and
            mature test benches. SmartCAN is not positioned as a replacement for every advanced workflow.
          </p>
        </article>
        <article className="data-panel">
          <p className="eyebrow">SmartCAN focus</p>
          <h2>Faster interpretation</h2>
          <p>
            SmartCAN focuses on making CAN log interpretation, live capture, OBD data analysis, and candidate signal
            discovery approachable while preserving access to raw CAN IDs and payload bytes.
          </p>
        </article>
        <article className="data-panel">
          <p className="eyebrow">Best fit</p>
          <h2>Useful when context is incomplete</h2>
          <p>
            If you do not have a complete DBC file or are exploring an unfamiliar ECU network, SmartCAN can assist with
            filtering, summaries, exports, and verified community signal hints.
          </p>
        </article>
      </section>

      <section className="band">
        <div className="section-heading compact">
          <p className="eyebrow">Comparison table</p>
          <h2>Category-level comparison</h2>
        </div>
        <div className="table-wrap">
          <table className="can-table live comparison-table">
            <thead><tr><th>Area</th><th>Traditional CAN tools</th><th>SmartCAN</th></tr></thead>
            <tbody>
              {comparisonRows.map(([area, traditional, smartcan]) => (
                <tr key={area}><td>{area}</td><td>{traditional}</td><td>{smartcan}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="section two-column">
        <article className="status-panel">
          <p className="eyebrow">Try the workflow</p>
          <h2>Start with real CAN data</h2>
          <p>
            Upload a CAN log to inspect raw frames, or browse community signals to see how verified hints appear before
            numeric formula decoding is added.
          </p>
          <div className="inline-actions">
            <a className="button primary" href="/analyzer">Open CAN Log Analyzer</a>
            <a className="button secondary" href="/decode">Open Community Decode</a>
          </div>
        </article>
        <article className="code-panel">
          <p className="eyebrow">Related guide</p>
          <h2>Learn CAN decoding basics</h2>
          <p>Read the decoder guide for CAN IDs, payload bytes, signals, scaling, offsets, and DBC files.</p>
          <a className="button secondary" href="/can-bus-decoder-guide">Read decoder guide</a>
        </article>
      </section>
    </main>
  );
}
